import { useElementVisibility as useElementVisibilityCore } from '@vueuse/core';
import { ref, watch } from 'vue';

export default function useElementVisibility(element) {
  const visioned = ref(false);
  const visible = useElementVisibilityCore(element);

  watch(visible, () => {
    if (!visioned.value) {
      visioned.value = true;
    }
  });

  return { visioned, visible };
}
